export function getPlaceholder(locations, location_id) {
  let name = locations?.find(location => location._id === location_id)?.name
  return `Location: ${name}`
}
